module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Acknowledgments"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter01"
    }
  }, [_vm._v("1."), _c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_vm._v("The Pleasures of Backwardness / Zsuzsa Gille, Cristofer Scarboro, and Diana Mincytė")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter02"
    }
  }, [_vm._v("2."), _c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_vm._v("Consuming Dialogues: Pleasure, Restraint, Backwardness, and Civilization in Eastern Europe / Mary Neuburger")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_vm._v("Just Rewards: The Social Contract and Communism’s Hard Bargain with the Citizen-Consumer / Patrick Hyder Patterson")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_vm._v("Conceptualizing Consumption in the Polish People’s Republic / Brian Porter-Szűcs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_vm._v("Oranges and the New Black: Importing, Provisioning, and Consuming Tropical Fruits and Coffee in the GDR, 1971–89 / Anne Dietrich")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_vm._v("VCRs, Modernity, and Consumer Culture in Late State Socialist Poland / Patryk Wasiak")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_vm._v("The Enchantment of Imaginary Europe: Consumer Practices in Post-Soviet Ukraine / Tania Bulakh")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_vm._v("The Late Socialist Good Life and Its Discontents: "), _c('i', [_vm._v("Bit")]), _vm._v(", "), _c('i', [_vm._v("Kultura")]), _vm._v(", and the Social Life of Goods / Cristofer Scarboro")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_vm._v("The Prosumerist Resonance Machine: Rethinking Political Subjectivity and Consumer Desire in State Socialism / Zsuzsa Gille and Diana Mincytė")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0156f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 72
// module chunks = 0